<template>
  <v-card>
    <v-card-title><h3>Inventory Report</h3></v-card-title>
    <v-card-text>

      <v-layout row wrap>

        <v-flex xs12 md4 class="text-xs-center" px-1 mt-2>
          <v-flex>
            <v-select
              v-model="category"
              :items="categories"
              label="Select Category"
            />
          </v-flex>
        </v-flex>

        <v-flex xs12 md3 class="text-xs-center" px-1 mt-2>
          <v-flex class="date__picker">
            <v-menu
              v-model="menu"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="fromDate"
                  label="Start Date"
                  prepend-icon="event"
                  readonly
                  clearable
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="fromDate" @input="menu = false"></v-date-picker>
            </v-menu>
          </v-flex>
        </v-flex>

        <v-flex xs12 md3 class="text-xs-center" px-1 mt-2>
          <v-flex class="date__picker">
            <v-menu
              v-model="menu1"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="toDate"
                  label="End Date"
                  prepend-icon="event"
                  readonly
                  clearable
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="toDate" @input="menu1 = false"></v-date-picker>
            </v-menu>
          </v-flex>
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex>
          <v-flex xs12 md12>
            <v-data-table
              :items="items"
              :headers="header"
              :loading="loading"
              item-key="id"
              hide-actions
              disable-initial-sort
            >
              <template slot="items" slot-scope="props">
                <tr>
                  <td>{{ props.item.name }}</td>
                  <td>{{ props.item.quantity }}</td>
                </tr>
              </template>
            </v-data-table>
            <div class="align-right">
              <v-btn @click="exportToCSV(items)">Export to CSV</v-btn>
            </div>
          </v-flex>
        </v-flex>
      </v-layout>

    </v-card-text>
  </v-card>
</template>

<script>
  import { mapGetters } from 'vuex'
  import _ from 'lodash'
  import moment from 'moment'

  export default {
    computed: {
      ...mapGetters({
        allCases: 'casesWithServicesCommissions',
        categories: 'productsCategories'
      })
    },
    data () {
      return {
        menu: false,
        menu1: false,
        fromDate: null,
        toDate: null,
        category: null,
        items: [],
        header: [
          { text: 'Product', value: 'name' },
          { text: 'Quantity', value: 'quantity' }
        ],
        loading: true
      }
    },
    watch: {
      fromDate () {
        this.filterCases()
      },
      toDate () {
        this.filterCases()
      },
      category () {
        this.filterCases()
      }
    },
    methods: {
      filterCases () {
        let filteredCases = this.allCases

        if (this.fromDate !== null) {
          filteredCases = filteredCases.filter(c => moment(c.created_at).format('YYYY-MM-DD') >= moment(this.fromDate).format('YYYY-MM-DD'))
        }
        if (this.toDate !== null) {
          filteredCases = filteredCases.filter(c => moment(c.created_at).format('YYYY-MM-DD') <= moment(this.toDate).format('YYYY-MM-DD'))
        }

        filteredCases = _.sortBy(filteredCases, ['id']).reverse()

        let allServices = []
        filteredCases.map(item => {
          item.services.map(service => allServices.push(service))
        })

        if (this.category !== null) {
          allServices = allServices.filter(service => {
            return service.service && service.service.categories_id === this.category
          })
        }

        let services = []
        allServices.map(service => {
          if (service && service.service && service.pivot && service.pivot.quantity > 0) {
            if (services.length > 0 && services.find(serviceInServices => serviceInServices.name === service.service.name)) {
              services.find(serviceInServices => serviceInServices.name === service.service.name).quantity += service.pivot.quantity
            } else {
              services.push({ name: service.service.name, quantity: service.pivot.quantity })
            }
          }
        })

        this.items = services
      },
      exportToCSV (cases) {
        const rows = []
        rows.push(['Product', 'Quantity'])
        cases.forEach(item => {
          rows.push([item.name, item.quantity])
        })

        const periodStart = this.fromDate ? this.fromDate.toLowerCase().replace(/ /g, '_') : null
        const periodEnd = this.toDate ? this.toDate.toLowerCase().replace(/ /g, '_') : null
        let period = ''
        if (periodStart) period += `_from_${periodStart}`
        if (periodEnd) period += `_to_${periodEnd}`

        let category = this.category ? this.getCategoryById(this.category) : ''

        let csvContent = 'data:text/csv;charset=utf-8,' + rows.map(e => e.join(',')).join('\n')
        let encodedUri = encodeURI(csvContent)
        // window.open(encodedUri)

        let link = document.createElement('a')
        link.setAttribute('href', encodedUri)
        link.setAttribute('download', `${category}inventory_report${period}.csv`)
        document.body.appendChild(link)

        link.click()
      },
      getCategoryById (id) {
        return `${this.categories.find(category => category.id === id).name}_`.toLowerCase()
      }
    },
    created () {
      this.$store.dispatch('loadAllCases').then(() => {
        this.filterCases()
        this.loading = false
      })
      if (this.$store.state.plans.all.length === 0) this.$store.dispatch('getAllPlans')
      if (this.$store.state.products.categories.length === 0) this.$store.dispatch('getProductsCategories')
      if (this.$store.state.products.all.length === 0) this.$store.dispatch('getAllProducts')
      if (this.$store.state.products.caskets.length === 0) this.$store.dispatch('getAllProducts')
    }
  }
</script>

<style scoped>
  .align-right {
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// InventoryReport.vue?195d9ac9